export const AionSectionCard = ({ title, eyebrow, subtitle, action, testId, className = "", children }) => (
  <section className={`aion-section-card${className ? ` ${className}` : ""}`} data-testid={testId}>
    <div className="aion-section-header">
      <div>
        {eyebrow ? <p className="aion-section-eyebrow" data-testid={`${testId}-eyebrow`}>{eyebrow}</p> : null}
        <h2 className="aion-section-title" data-testid={`${testId}-title`}>{title}</h2>
        {subtitle ? <p className="aion-section-subtitle" data-testid={`${testId}-subtitle`}>{subtitle}</p> : null}
      </div>
      {action ? <div className="aion-section-action" data-testid={`${testId}-action`}>{action}</div> : null}
    </div>
    {children}
  </section>
);